import { UploadProps } from 'antd';
import Dragger from 'antd/es/upload/Dragger';
import FileIcon from 'assets/icons/file';
import { EFileStatus } from 'components/features/file-uploader/enum';
import { CustomFile } from 'components/features/file-uploader/types';
import { MAXIMUM_SIZE_IN_MB, VALID_FORMAT } from 'constants/files';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatFileSize } from 'utils/format';

interface FileDraggerProps {
  uploadProps: UploadProps;
  fileList: CustomFile[];
  disabled?: boolean;
}

const FileDragger: React.FC<FileDraggerProps> = ({
  uploadProps,
  fileList,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <Dragger {...uploadProps} disabled={disabled} className="bg-white">
        <div className="flex justify-center">
          <FileIcon />
        </div>
        <p className="ant-upload-text">
          {t('file.dragAndDrop')}{' '}
          <span className="text-blue-600 underline">
            {t('file.chooseFile')}
          </span>
        </p>
        <p className="ant-upload-hint text-gray-500">
          {t('file.maximumFileSize', {
            size: MAXIMUM_SIZE_IN_MB,
          })}
          <br />
          {t('file.supportedFormat', {
            formats: VALID_FORMAT.join(', '),
          })}
        </p>
      </Dragger>

      {fileList.length > 0 && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm text-gray-600">
            {t('file.totalFilesSize', {
              totalFiles: fileList.filter(
                (file) => file.status === EFileStatus.DONE
              ).length,
              totalSize: formatFileSize(
                fileList
                  .filter((file) => file.status === EFileStatus.DONE)
                  .reduce((acc, file) => acc + (Number(file.size) || 0), 0)
              ),
            })}
          </p>
        </div>
      )}
    </div>
  );
};

export default FileDragger;
